/**
 * Origem Flow: ordem escolhida pelo usuário (arrastar e soltar) para itens
 * fixos da interface — ícones do AppRail, painel Início e seções da sidebar.
 * Persistida no localStorage por chave; ids desconhecidos armazenados são
 * ignorados e ids novos do produto entram na posição padrão.
 */
const PREFIX = 'origemFlowSidebarOrder:'

export function readSidebarOrder(key, defaults) {
  try {
    const raw = localStorage.getItem(PREFIX + key)
    if (!raw) {
      return [...defaults]
    }
    const stored = JSON.parse(raw)
    if (!Array.isArray(stored)) {
      return [...defaults]
    }
    const known = stored.filter((id) => defaults.includes(id))
    const missing = defaults.filter((id) => !known.includes(id))
    return [...known, ...missing]
  } catch (error) {
    return [...defaults]
  }
}

export function writeSidebarOrder(key, order) {
  try {
    localStorage.setItem(PREFIX + key, JSON.stringify(order))
  } catch (error) {
    // Sem localStorage a ordem só não persiste entre sessões.
  }
}
